import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {TimelineLite} from "gsap";
import {Game} from "../Game";
import {Sound} from "../sound/Sound";
import {Config} from "../config/Config";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";
import {GameFeatureMode, SYMBOL} from "../enums/Enum";
import {IStickyScatter} from "../server/Data";

export class NormalBetPresentation implements FlowStatePresentation {

    constructor() {

    }

    public start(flowStateController: FlowStateController) {
        const tl: TimelineLite = new TimelineLite({onComplete: () => flowStateController.finish()});
        const delay: number = Game.apiPlugin.settings.get(APISetting.FAST_SPIN, false) ? 0 : Config.STEP_DURATION;
        Game.enhancerView.setDarkMode(Game.buyFeatureName === "GOD_MODE");
        if (Game.totalWinView.showEndTl?.isActive()) {
            Game.totalWinView.showEndTl.timeScale(3);
        }
        tl.add(() => {
            Game.foregroundElements.waysCounter.updatePossibleWaysCounter(true);
            Game.foregroundElements.featureLogoContainer.resetAll();
            Game.winHighlightView.reset();
            Game.enhancerView.close();
            Game.soundPlayer.playSound(Sound.REELS_SPINNING, undefined, Number.MAX_VALUE);
            Game.reelView.reset();
        });
        if (Game.model.data.nextMode !== GameFeatureMode.NORMAL) { //show s2 lock frame
            tl.add(() => {
                Game.effectsView.reset();
                Game.model.data.lockedS2inSFS.forEach((stickyScatterData: IStickyScatter) => {
                    Game.stickyView.addScatters(stickyScatterData.x, stickyScatterData.y, stickyScatterData.sym as SYMBOL);
                });
            })
        }
        tl.add(Game.reelView.reelModels[0].start(false), 0);
        tl.add(Game.reelView.reelModels[1].start(false), delay);
        tl.add(Game.reelView.reelModels[2].start(false), delay * 2);
        tl.add(Game.reelView.reelModels[3].start(false), delay * 3);
        tl.add(Game.reelView.reelModels[4].start(false), delay * 4);
    }
}